import React from 'react';
type CardProps = {
  title?: string;
  children: ReactNode;
  className?: string;
};
export function Card({
  title,
  children,
  className = ''
}: CardProps) {
  return <div className={`bg-card rounded-lg border border-border shadow-sm ${className}`} data-id="element-1633">
      {title && <div className="px-6 py-4 border-b border-border" data-id="element-1634">
          <h2 className="text-lg font-medium text-card-foreground" data-id="element-1635">{title}</h2>
        </div>}
      <div className="p-6" data-id="element-1636">{children}</div>
    </div>;
}